import React from "react"
import { Stack } from "@chakra-ui/react"

import { VideoItem, VideoAttributes, VideoCategories, VideoDescription, VideoTitle } from "@app/components/Video"
import TileCarousel from "@app/components/TileCarousel/TileCarousel"
import useVideoNormaliser from "@app/hooks/useVideoNormaliser"

export interface VideoCarouselProps {
  videos: GatsbyTypes.SanitySectionFeaturedVideos["videos"]
  carouselSettings?: GatsbyTypes.SanityCarouselSettings
  handleTrackingClick: VoidFunction
}

const VideoCarousel = ({ videos, carouselSettings, handleTrackingClick }: VideoCarouselProps) => {
  const { normaliseVideos } = useVideoNormaliser()
  const items = normaliseVideos(videos as GatsbyTypes.SanityVideo[])

  return (
    <TileCarousel carouselSettings={carouselSettings} spaceBetweenTiles={16}>
      {items.map(item => (
        <VideoItem key={item?.key} video={item} handleTrackingClick={handleTrackingClick}>
          <Stack spacing={2} mb={3.5} key={item.key} width={["283px", "648px"]} textAlign="left" as="article">
            <Stack>
              <VideoCategories />
              <VideoTitle noOfLines={1} />
              <VideoDescription noOfLines={4} />
            </Stack>
            <VideoAttributes />
          </Stack>
        </VideoItem>
      ))}
    </TileCarousel>
  )
}

export default React.memo(VideoCarousel)
